<div class="flex flex-wrap items-center gap-2 py-2">
  <button
    type="button"
    (click)="openFieldsModal.emit()"
    class="h-8 px-3 rounded-[var(--r-sm)] text-sm font-medium text-[var(--muted)] hover:bg-[var(--hover)] hover:text-[var(--text)] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)] inline-flex items-center gap-1.5"
  >
    <lucide-icon name="columns-3" class="h-4 w-4"></lucide-icon>
    {{ 'listViewColumnBar.fields' | t }}
  </button>
  <button
    type="button"
    (click)="addColumn.emit()"
    class="h-8 w-8 rounded-[var(--r-sm)] flex items-center justify-center text-[var(--muted)] hover:bg-[var(--hover)] hover:text-[var(--text)] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)]"
    [attr.title]="'listViewColumnBar.addColumnTitle' | t"
  >
    <lucide-icon name="plus" class="h-4 w-4"></lucide-icon>
  </button>
  @for (col of columns(); track col.id) {
    <div
      class="h-8 pl-2.5 pr-1.5 rounded-[var(--r-sm)] bg-[var(--hover)]/60 border border-[var(--border)] flex items-center gap-1.5 group"
    >
      <span class="text-sm text-[var(--text)]">{{ col.label }}</span>
      <button
        type="button"
        (click)="hideColumn.emit(col.id)"
        class="h-5 w-5 rounded flex items-center justify-center text-[var(--muted)] hover:bg-[var(--hover)] hover:text-[var(--text)] transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)]"
        [attr.aria-label]="'listViewColumnBar.hideColumnAria' | t : { column: col.label }"
      >
        <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
      </button>
    </div>
  }
</div>
